<template>
	<div class="paddBottom">
		<IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
		<div class="main">
			<div class="conner">
				<div class="conner-top">
					<div class="conner-top-left">
						<h1>{{ astronEvent.title }}</h1>
						<p>
							Trigger Time： {{ astronEvent.triggerTime }} UTC 
						</p>
						<P> Location (J2000): RA = {{ astronEvent.ra }}, Dec = {{ astronEvent.declination }}</P>
						<div class="bootom" @click="downLoadEvent">
							<!-- <p>Light curve</p> -->
							<i class="el-icon-download"></i>
							<p>Download</p>
						</div>
					</div>
					<div class="conner-top-right">
						<el-carousel indicator-position="none" :interval="5000">
							<el-carousel-item v-for="(item, index) in imgList" :key="index">
								<img  v-if="item != 'img/modeurl.e77989e6.png'" :src="item" alt="图片找不到了" width="100%" height="90%" />
								<img  v-if="item == 'img/modeurl.e77989e6.png'" :src="item" alt="图片找不到了" width="100%" height="100%" />
								<!-- <el-botton class="small">Picture From</el-botton> -->
								<div class="btn bootom" @click="clickBtn(item)" v-if="item != 'img/modeurl.e77989e6.png'">
									<i class="el-icon-info"></i>
									<div style="padding:0">Picture From</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<div class="table">
					<MessageVue />
				</div>
			</div>
		</div>
		<el-dialog
		:show-close="false"
		  title="Picture From"
		  :visible.sync="dialogVisible"
		  width="30%"
		  >
		  <div class="picSpan" style="text-align:left;display:block;display:flex">
			  <div style="width:150px;font-weight:700">Picture Url:</div>
			  <div>{{picUrl}}</div>
		  </div>
		  <!-- <span slot="footer" class="dialog-footer" v-if="picUrl != 'none'"> -->
		   <!-- <el-button v-clipboard:copy="picUrl" v-clipboard:success="onCopy" >Close</el-button> -->
		    <!-- <el-button @click="dialogVisible = false" style="width:100px">Close</el-button> -->
		    <!-- <el-button type="primary" @click="goPicurl" style="width:100px">Go</el-button> -->
		  <!-- </span> -->
			<div class="dialog-botton">
			  <div class="botton-left" @click="dialogVisible = false">
			    <p>Close</p>
			  </div>
			  <div class="botton-right" @click="goPicurl">
			    <p>Go</p>
			  </div>
			</div>
			<div class="dialog-icon">
			  <i class="el-icon-circle-close" @click="dialogVisible = false"></i>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import ClipboardJS from 'clipboard'
	import IndexHeaderOthers from "../header/indexHeaderOthers.vue";
	import MessageVue from "../page/Message.vue";
	export default {
		name: "subEvents",
		components: {
			IndexHeaderOthers,
			MessageVue
		},
		data() {
			return {
				imgList: [
					// require("../../assets/modeurl.png"),
					// require("../../assets/modeurl.png"),
					// require("../../assets/modeurl.png"),
				],

				id: this.$route.query.eventId,
				astronEvent: {},
				dialogVisible:false,
				picUrl:''
			};
		},
		methods: {
			clickBtn(item){
				this.dialogVisible = true
				if(item != 'img/modeurl.e77989e6.png'){
					this.picUrl = item
				}else{
					this.picUrl = 'none'
				}
			},
			goPicurl(){
				this.dialogVisible = false
				if(this.picUrl != 'none'){
					window.location.href = this.picUrl
				}
			},
			onCopy(){
				this.dialogVisible = false
				this.$message.success('Copy  Success')
			},
			downLoadEvent(){
				
				// window.location.href = "/cms-middle/astronMessage/export?eventId=" + this.id
				// window.open("/cms-middle/astronMessage/export?eventId=" + this.id)
				// this.$fetchGet("/cms-middle/astronMessage/export?eventId=" + this.id).then(res => {
				// 	console.log(res)
				// })
				var url = process.env.VUE_APP_BASE_API + "/cms-middle/astronMessage/export?eventId=" + this.id
				var fileName = 'Message of ' + this.astronEvent.title + '.xlsx'
				const el = document.createElement('a');
				      el.style.display = 'none';
				      el.setAttribute('target', '_blank');
				      fileName && el.setAttribute('download', fileName);
				      el.href = url;
				      console.log(el);
				      document.body.appendChild(el);
				      el.click();
				      document.body.removeChild(el)
			},
			getData() {
				let that = this
				this.$fetchGet("/cms-middle/astronEvent/queryById?id=" + this.id)
					.then((res) => {
						this.astronEvent = res.astronEvent;
						console.log(res)
						console.log(this.astronEvent.lcUrl)
						if (this.astronEvent.lcUrl) {
							console.log(1)
							if(this.astronEvent.lcUrl.substr( -1) == ']'){
								var b = eval('(' + this.astronEvent.lcUrl + ')')
							}else{
								var b = [
								  	require("../../assets/modeurl.png"),
								  	require("../../assets/modeurl.png"),
								  	require("../../assets/modeurl.png"),
								  ]
							}
							console.log(this.astronEvent.lcUrl.substr( -1))
							// var b = eval('(' + this.astronEvent.lcUrl + ')')
							// var b = eval(this.astronEvent.lcUrl)
							// console.log(b)
						}else{
							console.log(1)
							var b = [
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  ]
						}
						console.log(1)
						var a = []
						for (var i = 0; i < b.length; i++) {
							if(!this.getPic(b[i])){
								b.splice(i,1)
							}
						}
						console.log(b)
						
						Promise.all(b.map(src => this.getPromises(src))).then(data => {
						  console.log(data);
						  if(data.length == 0){
							  this.imgList = [
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  ]
						  }else if(data[0] == ' '){
							  this.imgList = [
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  	require("../../assets/modeurl.png"),
							  ]
						  }else{
							  this.imgList = data
						  }
						});
					})
					.catch((err) => {});
				//
			},
			getPromises(src) {
			  let img = new Image();
			  img.src = src;
			  return new Promise(function(resolve, reject) {
			    img.onerror = () => {
			      resolve(' ');
			    };
			    img.onload = () => {
			      resolve(src);
				  console.log(src)
			    };
			  });
			},
			getPic(a) {
				var strFilter = ".jpeg|.gif|.jpg|.png|.bmp|.pic|.svg|"
				if (a.indexOf(".") > -1) {
					var p = a.lastIndexOf(".");
					var strPostfix = a.substring(p, a.length) + '|';
					strPostfix = strPostfix.toLowerCase();
					if (strFilter.indexOf(strPostfix) > -1) {
						return true;
					}
				}
				return false;
			}
		},
		mounted() {
			this.getData();
			// console.log(this.$route.query.eventId)
			// window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
		},
	};
</script>
<style scoped lang="less">
	.dialog-botton {
	  display: flex;
	  margin-top: 32px;
	  width: 100%;
	  justify-content: center;
	}
	.dialog-icon {
	  position: absolute;
	  right: 16px;
	  top: 16px;
	}
	.el-dialog{
		border-radius:0!important
	}
	.el-icon-circle-close {
	  font-size: 23px;
	  color: #168ec7;
	  cursor: pointer;
	}
	.botton-left {
	  width: 83px;
	  height: 33px;
	  background: #e6ebf3;
	  border-radius: 17px;
	  text-align: center;
	  cursor: pointer;
	  margin-right: 10px;
	}
	
	.botton-left > p {
	  font-size: 14px;
	  height: 33px;
	  font-family: Alibaba Sans;
	  font-weight: bold;
	  color: #666666;
	  line-height: 4px;
	}
	
	.botton-right {
	  width: 83px;
	  height: 33px;
	  background: #168ec7;
	  border-radius: 17px;
	  text-align: center;
	  cursor: pointer;
	}
	
	.botton-right > p {
	  font-size: 14px;
	  height: 33px;
	  font-family: Alibaba Sans;
	  font-weight: bold;
	  color: #ffffff;
	  line-height: 4px;
	}
	.small{
		    position: absolute;
		    bottom: 10px;
		    width: 100%;
		    word-break: break-all;
			padding: 12px;
	}
	.main {
		position: relative;
		margin-top: -70px;
		z-index: 99;
		width: 100%;
		height: auto;
		background: #fff;
		border-radius: 0 120px 0 0;
	}
	.btn{
		position:absolute;
		bottom:10px;
		left:10px;
		color: #168ec7;
		font-size:14px;
		cursor:pointer
	}
	.conner {
		width: 1050px;
		margin: 0 auto;
		text-align: left;
	}

	.conner-top {
		padding-top: 48px;
		display: flex;
	}

	.conner-top-left {
		width: 525px;
		height: 318px;
		margin-right: 20px;
		// background: linear-gradient(90deg, rgba(20,64,114, 0.3), rgba(22,128,183,0.3));
		background-color: #ffffff;
		border: 1px solid #168ec7;
	}

	.conner-top-left>h1 {
		margin-left: 33px;
		margin-top: 34px;
		font-size: 24px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #168ec7;
		line-height: 23px;
	}

	.conner-top-left>p {
		margin-left: 33px;
		width: 335px;
		// height: 45px;
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: 500;
		color: #168ec7;
		line-height: 31px;
	}

	.bootom {
		margin-top: 123px;
		// margin-left: 10px;
		display: flex;
		cursor:pointer;
		align-items: center;
	}

	.bootom>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: 500;
		color: #168ec7;
		line-height: 31px;
	}

	.el-icon-download {
		margin-left: 8px;
		font-size: 20px;
		width: 24px;
		color: #168ec7;
	}

	.conner-top-right {
		flex: 1;
		background: #ffffff;
	}

	.echartsLine {
		width: 502px;
		height: 260px;
	}

	/deep/ .el-carousel__container,
	.el-carousel {
		height: 100% !important;
	}
</style>
